import { render } from "./PricingRow.vue?vue&type=template&id=607ed514"
import script from "./PricingRow.vue?vue&type=script&lang=js"
export * from "./PricingRow.vue?vue&type=script&lang=js"

import "./PricingRow.vue?vue&type=style&index=0&id=607ed514&lang=css"

import exportComponent from "C:\\Users\\Loïc\\Downloads\\smsyou\\avalon\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__